import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { ActivityIndicator, View, StyleSheet } from 'react-native';
import { useAuth } from '../contexts/AuthContext';

import AuthStack from './AuthStack';
import MainTabs from './MainTabs';

// Detail-Screens (werden über Main-Tabs gelegt)
import StoreDetailScreen from '../screens/StoreDetailScreen';
import StoreSortScreen from '../screens/StoreSortScreen';
import ArticleDetailScreen from '../screens/ArticleDetailScreen';
import AddItemScreen from '../screens/AddItemScreen';

const Stack = createStackNavigator();

const AppNavigator = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#2E7D32" />
      </View>
    );
  }

  return (
    <NavigationContainer>
      {isAuthenticated ? (
        <Stack.Navigator>
          <Stack.Screen 
            name="MainTabs" 
            component={MainTabs}
            options={{ headerShown: false }}
          />
          <Stack.Screen 
            name="StoreDetail" 
            component={StoreDetailScreen}
            options={({ route }) => ({ 
              title: route.params?.storeName || 'Einkaufsliste',
              headerStyle: {
                backgroundColor: '#2E7D32',
              },
              headerTintColor: '#fff',
              headerTitleStyle: {
                fontWeight: 'bold',
              },
            })}
          />
          <Stack.Screen 
            name="StoreSort" 
            component={StoreSortScreen}
            options={({ route }) => ({ 
              title: `Sortierung: ${route.params?.storeName || 'Laden'}`,
              headerStyle: {
                backgroundColor: '#2E7D32',
              },
              headerTintColor: '#fff',
              headerTitleStyle: {
                fontWeight: 'bold',
              },
            })}
          />
          <Stack.Screen 
            name="ArticleDetail" 
            component={ArticleDetailScreen}
            options={{
              title: 'Artikel bearbeiten',
              headerStyle: {
                backgroundColor: '#2E7D32',
              },
              headerTintColor: '#fff',
              headerTitleStyle: {
                fontWeight: 'bold',
              },
            }}
          />
          <Stack.Screen 
            name="AddItem" 
            component={AddItemScreen}
            options={{
              title: 'Artikel hinzufügen',
              headerStyle: {
                backgroundColor: '#2E7D32',
              },
              headerTintColor: '#fff',
              headerTitleStyle: {
                fontWeight: 'bold',
              },
              presentation: 'modal',
            }}
          />
        </Stack.Navigator>
      ) : (
        <AuthStack />
      )}
    </NavigationContainer>
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
  },
});

export default AppNavigator;

